import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "messagesContainer"]

  connect() {
    // Setup escape key handler
    this.boundHandleEscape = this.handleEscape.bind(this)
    console.log("Wizard AI Assistant controller connected")
  }

  openModal(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    console.log("Opening modal...")
    // Show the modal
    this.modalTarget.classList.remove("hidden")

    // Lock body scroll
    document.body.classList.add("overflow-hidden")

    // Add escape key listener
    document.addEventListener("keydown", this.boundHandleEscape)

    // Focus the input after modal renders
    setTimeout(() => {
      const input = this.modalTarget.querySelector('[data-bartender-chat-target="input"]')
      if (input) input.focus()
    }, 100)
  }

  closeModal(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    console.log("Closing modal...")
    // Hide the modal
    this.modalTarget.classList.add("hidden")

    // Unlock body scroll
    document.body.classList.remove("overflow-hidden")

    // Remove escape key listener
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  closeOnBackdrop(event) {
    // Only close if clicking directly on the backdrop, not on children
    if (event.target === event.currentTarget) {
      this.closeModal()
    }
  }

  preventClose(event) {
    // Prevent clicks inside modal from bubbling to backdrop
    event.stopPropagation()
  }

  handleEscape = (event) => {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.boundHandleEscape)
  }
}
